import React, { useContext } from "react";
import "./offerManagementOverview.css"
import {
    Table, TableBody, TableCell, TableContainer, TableRow, Paper, Typography, Divider,
} from '@mui/material';
import OfferManagementContext from "../../../context/offerManagement.context";
import { isEmpty } from "../../../pages/utils/utils";

const FIRST_COLUMN_WIDTH = { width: '20%', minWidth: '20%' }
const SECOND_COLUMN_WIDTH = { width: '20%', minWidth: '20%' }
const THIRD_COLUMN_WIDTH = { width: '60%', minWidth: '60%' }

export default function OfferManagementOverview() {
    const { offerFieldData, emiTypeOptions, issuerOptions, emiData, OFFER_TYPE, offerDetailsById } = useContext(OfferManagementContext);

    const formatDateTime = (date) => {
        if (!date) return "";
        return new Intl.DateTimeFormat("en-US", {
            day: "2-digit",
            month: "short",
            year: "numeric",
            hour: "2-digit",
            minute: "2-digit",
            hour12: true,
        }).format(new Date(date));
    };
    const getHtml = (html) => {
        return <span className="offerDetailsOverviewContent" dangerouslySetInnerHTML={{ __html: html }}>
        </span>
    }
    const getAmountDetails = (amount) => {
        if (amount && amount > 0) return `${offerFieldData.currencySelected} ${amount}`
        return '-'
    };

    const OFFER_DETAIL_ORDER = [
        {
            title: 'Offer Title',
            value: 'offerTitle'
        },
        {
            title: 'Terms & Conditions',
            value: 'offerDescription',
            func: getHtml
        },
        {
            title: 'Min. Order Amount',
            value: 'minAmount',
            func: getAmountDetails
        },
        {
            title: 'Max. Order Amount',
            value: 'maxAmount',
            func: getAmountDetails
        },
        {
            title: 'Start Date & Time',
            value: 'offerStartDate',
            func: formatDateTime
        },
        {
            title: 'End Date & Time',
            value: 'offerEndDate',
            func: formatDateTime
        }
    ];

    return (
        <TableContainer component={Paper} sx={{ border: '1px solid #e0e0e0', borderRadius: '8px' }}>
            <Table aria-label="offer details table">
                <TableBody>
                    {
                        OFFER_DETAIL_ORDER.map((item, i) => (
                            <TableRow key={item.title}>
                                <TableCell sx={FIRST_COLUMN_WIDTH}>
                                    {i === 0 && (<Typography className="offerDetails">Offer Details</Typography>)}
                                </TableCell>
                                <TableCell sx={SECOND_COLUMN_WIDTH}>
                                    <Typography className="offerDetailsOverviewHeading">{item.title}</Typography>
                                </TableCell>
                                <TableCell sx={THIRD_COLUMN_WIDTH}>
                                    <Typography className="offerDetailsOverviewContent">
                                        {typeof item.func === 'function' ? item.func(offerFieldData[item.value]) : offerFieldData[item.value]}
                                    </Typography>
                                </TableCell>
                            </TableRow>
                        ))
                    }
                </TableBody>
            </Table>
            <Divider sx={{ my: 2 }} />
            <Table aria-label="applicable on table">
                <TableBody>
                    <TableRow>
                        <TableCell sx={FIRST_COLUMN_WIDTH}>
                            <Typography className="offerDetails">  Applicable On  </Typography>
                        </TableCell>
                        <TableCell sx={SECOND_COLUMN_WIDTH}>
                            <Typography className="offerDetailsOverviewHeading">EMI Option</Typography>
                        </TableCell>
                        <TableCell sx={THIRD_COLUMN_WIDTH}>
                            <Typography className="offerDetailsOverviewContent">
                                {emiTypeOptions.find(d => d.brand === offerFieldData.selectedEmiOption)?.title}
                            </Typography>
                        </TableCell>
                    </TableRow>

                    <TableRow>
                        <TableCell sx={FIRST_COLUMN_WIDTH}></TableCell>
                        <TableCell sx={SECOND_COLUMN_WIDTH}>
                            <Typography className="offerDetailsOverviewHeading">Issuer</Typography>
                        </TableCell>
                        <TableCell sx={THIRD_COLUMN_WIDTH}>
                            <Typography className="offerDetailsOverviewContent">
                                {issuerOptions.find(d => d.brand === offerFieldData.selectedIssuer)?.title}
                            </Typography>
                        </TableCell>
                    </TableRow>

                    <TableRow>
                        <TableCell sx={FIRST_COLUMN_WIDTH}>
                            <Typography className="offerDetails"> </Typography>
                        </TableCell>
                        <TableCell sx={{ ...SECOND_COLUMN_WIDTH, verticalAlign: 'baseline' }} >
                            <Typography className="offerDetailsOverviewHeading">EMI Tenures</Typography>
                        </TableCell>
                        <TableCell>
                            {
                                emiData.map(i => {
                                    let { emiMethod, isChecked, offerType } = i;
                                    let { duration, merchantBorneInterestRate } = emiMethod;
                                    let offer = OFFER_TYPE.find(item => item.value === offerType)?.title;
                                    const isOfferAlreadyActive = !isEmpty(i?.emiMethod?.applicableOffer) && offerDetailsById.code !== i?.emiMethod?.applicableOffer?.code;

                                    return isChecked && !isOfferAlreadyActive && (
                                        <TableRow sx={THIRD_COLUMN_WIDTH} key={duration}>
                                            <TableCell sx={{ ...THIRD_COLUMN_WIDTH, paddingLeft: 0, paddingRight: 0, paddingTop: 0 }}>
                                                <Typography className="offerDetailsOverviewContent">{`${duration} months | ${offer} | ${merchantBorneInterestRate}% interest borne by merchant`}</Typography>
                                            </TableCell>
                                        </TableRow>
                                    )
                                })
                            }
                        </TableCell>
                    </TableRow>

                </TableBody>
            </Table>
        </TableContainer>
    )
}